export const PasswordLeakAssessmentAction = {
  CONFIRM_PW: 'PL_CONFIRM_PW',
  CONFIRM_GUARDIAN: 'PL_CONFIRM_GUARDIAN',
  CHANGE_PW: 'PL_CHANGE_PW'
} as const

export type PasswordLeakAction = (typeof PasswordLeakAssessmentAction)[keyof typeof PasswordLeakAssessmentAction]

export const CommonConstants = {
  // page paths
  PRIVACY_NOTICES_PATH: `/policies/privacy-notices/latest`
} as const

export const ConsentConstants = {
  // consent codes
  PRIVACY_NOTICE: 'PN',
  PRIVACY_POLICY: 'PDP',

  // error messages
  FAILED_CONSENT_RESPONSE: `Failed getConsentBody`
}
